import Modal from 'react-modal';
import styled from 'styled-components';
import { FiXCircle, FiCheckCircle } from 'react-icons/fi';

interface IModalProps {
	modalIsOpen: boolean;
	closeModal: () => void;
}

export function ModalEndCampaignSuccess({ modalIsOpen, closeModal }: IModalProps) {
	return (
		<Modal
			isOpen={modalIsOpen}
			shouldCloseOnEsc={true}
			shouldCloseOnOverlayClick={true}
			onRequestClose={closeModal}
			ariaHideApp={false}
			style={{
				overlay: {
					width: '100%',
					zIndex: 9999999,
					margin: 'auto',
					backgroundColor: 'rgba(0, 0, 0, 0.75)',
				},
				content: {
					maxWidth: '450px',
					maxHeight: '300px',
					width: '80%',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					borderRadius: '15px',
					margin: '100px auto',
					padding: '20px',
					position: 'relative',
				},
			}}
		>
			<Container>
				<CloseButton onClick={closeModal}>
					<FiXCircle color="#174f68" size={30} />
				</CloseButton>

				<SuccessIcon>
					<FiCheckCircle color="#28a745" size={60} />
				</SuccessIcon>

				<Title>Encerrada com sucesso</Title>

				<ButtonContainer>
					<BackButton onClick={closeModal}>
						Voltar
					</BackButton>
				</ButtonContainer>
			</Container>
		</Modal>
	);
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 20px;
  text-align: center;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 15px;
  right: 15px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  
  &:hover {
    opacity: 0.7;
  }
`;

const SuccessIcon = styled.div`
  margin-bottom: 20px;
  margin-top: 10px;
`;

const Title = styled.h2`
  font-family: 'Nunito', sans-serif;
  font-size: 24px;
  font-weight: 600;
  color: #28a745;
  margin-bottom: 30px;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

const BackButton = styled.button`
  font-family: 'Nunito', sans-serif;
  font-size: 16px;
  font-weight: 600;
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 100px;
  background-color: #174f68;
  color: white;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    background-color: #0d3a4f;
  }
`; 